import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingRisks4 = props => (
    <section id="outsourcing-risks-section4" className="my pt-5">
        <div className='blue-shape'></div>
        <Container>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingRisks:section-4.text"
                    components={{
                        br: <br />,
                        outsourcingCost: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_cost.path')} className="link" />
                    }}
                />
            </p>
        </Container>
    </section>
);

export default OutsourcingRisks4;
